const getGoogleIcons = fonts => {
  const { googleIcons = '' } = fonts;
  return googleIcons;
};

export default getGoogleIcons;
